import { Material } from "@/types/editor/blocks";

export const materials = [
  { id: "yellow", name: "Yellow Fluoro Class 1 3M Reflective", color: "#C1C12D", ref:"Y", materialCode: "4083", brand: "3M", class: "1" },
  { id: "red", name: "Red Class 1 3M Reflective", color: "#AF0000", ref:"R", materialCode: "4088", brand: "3M", class: "1" },
  { id: "white", name: "White Class 1 3M Reflective", color: "#E8E8E8", ref:"W", materialCode: "4090", brand: "3M", class: "1" },
  // { id: "black", name: "Black Class 1 3M Reflective", color: "#000000", materialCode: "4091", brand: "3M", class: "1" },
] as Material[];